export default function Toolbar() {
    return {
        MuiToolbar: {
            defaultProps: {
                disableGutters: true,
            },
        },
    };
}
